import { memo } from 'react'

import type { IdentityFunction } from '../types'

/**
 * React.memo с улучшенной типизацией
 */
export const typedMemo: IdentityFunction = memo
